import { useQuery } from '@tanstack/react-query';
import { useAPI } from '@pella/cosmos-react';
import { QUERY_KEYS } from '../../utils/enums';

/**
 * Hook to fetch chart of accounts filtered by division, location, and cost center.
 * @param {string} division - The division code to filter by.
 * @param {string} location - The location code to filter by.
 * @param {string} costCenter - The cost center code to filter by.
 * @returns {object} Account query result with data, loading, success, and error states.
 */
export const useAccounts = (division, location, costCenter) => {
  const { api, apiReady } = useAPI();
  const { data, isLoading, isSuccess, isError, error } = useQuery({
    queryKey: [QUERY_KEYS.INV_MGMT_ACCOUNTS, division, location, costCenter],
    queryFn: () => api.invMgmt.getAccounts({ division, location, costCenter }),
    enabled: apiReady && Boolean(division) && Boolean(location) && Boolean(costCenter),
    staleTime: Number.POSITIVE_INFINITY,
  });
  return {
    accounts: data,
    accountsIsLoading: isLoading,
    accountsIsSuccess: isSuccess,
    accountsIsError: isError,
    accountsError: error,
  };
};
